export const BASE_URL = "http://braves-tracker-node-env.eba-dhgwipu3.us-east-2.elasticbeanstalk.com/";